import type { FC } from 'react';

import { ExperimentChatProvider } from '@apps/chatv2-shared-multilabel';
import type { AppProps } from '@eneco/next';
import { SessionProvider } from 'next-auth/react';

const EXPERIMENT_NAME = 'oxxio-chatbot-v2';

const SelfServiceApp: FC<AppProps> = ({ Component, pageProps: { session, featureVariants, ...pageProps }, router }) => {
  const isOxxioChatEnabled = featureVariants?.[EXPERIMENT_NAME] ?? true;

  return (
    <SessionProvider session={session} basePath={`${router.basePath}/api/auth`}>
      <ExperimentChatProvider isEnabled={isOxxioChatEnabled} defaultNamespace="oxxio-nl-b2c">
        <Component {...pageProps} />
      </ExperimentChatProvider>
    </SessionProvider>
  );
};

export default SelfServiceApp;
